import { gql, useQuery } from "@apollo/client";
import AddressView from "./AddressView";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import Button from "components/base/Button";
import { useParams } from "react-router-dom";
import BaseInfoView from "./BaseInfoView";
import OdooCustomerView from "./OdooCustomerView";

const FETCH_RETAILER_DETAIL = gql`
  query FETCH_RETAILER_DETAIL($id: ID!) {
    retailerCustomer(id: $id) {
      id
      email
      company
      vat
      user {
        groups {
          name
        }
      }
      belongToAgentUser {
        id
        email
      }
      discountOnPrepaid
      odooPartnerId

      billingAddressName
      billingAddressStreet1
      billingAddressStreet2
      billingAddressCity
      billingAddressState
      billingAddressZip
      billingAddressCountry

      shippingAddressName
      shippingAddressStreet1
      shippingAddressStreet2
      shippingAddressCity
      shippingAddressState
      shippingAddressZip
      shippingAddressCountry
    }
  }
`;

const RetailerDetailPage = () => {
  const { id } = useParams();
  const { loading, error, data } = useQuery(FETCH_RETAILER_DETAIL, {
    variables: { id },
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <Page
      title={`Retailer: ${data.retailerCustomer.email}`}
      backTo="./.."
      rightButtons={
        <div>
          <a
            href={
              process.env.REACT_APP_SERVER_ADMIN_URL +
              "retailer/customer/" +
              data.retailerCustomer.id
            }
            target="_blank"
          >
            Edit in Admin
          </a>
        </div>
      }
    >
      <div className="m-6 grid grid-cols-12 gap-6">
        <div className=" col-span-8 space-y-6">
          <div className="card">
            <h5>Basic Info</h5>
            <div className="mt-4 -mx-2">
              <BaseInfoView retailer={data.retailerCustomer} />
            </div>

            <hr />

            <div className="mt-4 flex">
              <div className="flex-1">
                <AddressView
                  title="Billing Address"
                  name={data.retailerCustomer.billingAddressName}
                  street1={data.retailerCustomer.billingAddressStreet1}
                  street2={data.retailerCustomer.billingAddressStreet2}
                  city={data.retailerCustomer.billingAddressCity}
                  state={data.retailerCustomer.billingAddressState}
                  zip={data.retailerCustomer.billingAddressZip}
                  country={data.retailerCustomer.billingAddressCountry}
                />
              </div>
              <div className="flex-1">
                <AddressView
                  title="Shipping Address"
                  name={data.retailerCustomer.shippingAddressName}
                  street1={data.retailerCustomer.shippingAddressStreet1}
                  street2={data.retailerCustomer.shippingAddressStreet2}
                  city={data.retailerCustomer.shippingAddressCity}
                  state={data.retailerCustomer.shippingAddressState}
                  zip={data.retailerCustomer.shippingAddressZip}
                  country={data.retailerCustomer.shippingAddressCountry}
                />
              </div>
            </div>
          </div>

          <div className="card">
            <h5>Recent Orders</h5>
            <div className="mt-4">...</div>
          </div>
        </div>
        <div className=" col-span-4 space-y-6 flex flex-col">
          <div className="card">
            <h4>Total Sales</h4>
            <div className="mt-4">...</div>
          </div>

          <div className="card">
            <h5 className="text-purple-600">Odoo Customer</h5>
            <div className="mt-4">
              {data.retailerCustomer.odooPartnerId ? (
                <OdooCustomerView
                  odooPartnerId={data.retailerCustomer.odooPartnerId}
                />
              ) : (
                "Not connected to Odoo"
              )}
            </div>
          </div>

          <div className="mx-1 flex justify-end">
            <Button danger>Delete Agent</Button>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default RetailerDetailPage;
